import { render, staticRenderFns } from "./baseinfo.vue?vue&type=template&id=02b6077c&scoped=true&"
import script from "./baseinfo.vue?vue&type=script&lang=js&"
export * from "./baseinfo.vue?vue&type=script&lang=js&"
import style0 from "./baseinfo.vue?vue&type=style&index=0&id=02b6077c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b6077c",
  null
  
)

export default component.exports